/**
 * Created by sshu on 2018/12/19
 */
import * as API from '@/service/index'

let proxy = process.env.NODE_ENV === 'development' ? '' : '/api';
let VUE_APP_EXAM = process.env.VUE_APP_EXAM
let VUE_APP_KKL = process.env.VUE_APP_KKL
let VUE_APP_SCREENURL = process.env.VUE_APP_SCREENURL

// 用户登录
export const login = (params) => {
    params.logintype = 5;
    return API.POST('/base/baselogin/login', params)
}

// 获取用户信息
export const findUserInfo = (params) => {
    // return API.GET('/userMgr/baselogin/getUserInfo', params)
    return API.GET('/userMgr/baselogin/getLoginUserInfo', params)
}

// 获取用户信息(和登录返回信息一致包含Token)
export const findLoginUserInfo = (params) => {
    return API.GET('/userMgr/baselogin/getLoginUserInfo', params)
}
// 根据token获取用户信息(和登录返回信息一致包含Token)
export const findLoginUserInfoByToken = (params) => {
    return API.GET('/userMgr/baselogin/getUserInfoByToken', params)
}

// 获取数据展板统计
export const findSchoolData = (params) => {
    return API.GET('/website/school/getSchoolData', params)
}

// 获取备课--资源上传Top10教师
export const findTeaWorkUpload = (params) => {
    return API.GET('/website/school/selectTeaWorkUpload', params)
}

// 获取作业--布置作业Top10教师
export const findTeachersList = (params) => {
    return API.GET('/website/school/getTeacherList', params)
}
// 获取作业--布置作业教师详情
export const findTeaHomeWork = (params) => {
    return API.GET('/website/school/selectTeaHomeWork', params)
}
// 获取作业--布置作业数量
export const findGiveHomeWork = (params) => {
    return API.GET('/website/school/selectGiveHomeWork', params)
}

// 获取维度--产品维度
export const findTeaUserNum = (params) => {
    return API.GET('/website/school/selectTeaUserNum', params)
}

// 获取大屏使用场景整体分布
export const findSituationSch = (params) => {
    return API.GET('/website/screen/getSituationSch', params)
}

// 获取教师使用场景整体分布
export const findTeacherScenes = (params) => {
    return API.GET('/website/school/teacherScenes', params)
}

// 获取运营人员相关接口
export const findGetList = (params) => {
    return API.GET('/operag/operschool/getOperSchoolList', params)
}
// 获取平台管理员下的学校列表
export const querySchoolPlatformList = (params) => {
    return API.GET('/platformManage/querySchoolPlatformList', params)
}

// 获取学校使用数量
export const findSchoolUseCount = (params) => {
    return API.GET('/website/school/schoolUseCount', params)
}

// 获取各个场景使用Top10
export const findSceneDetails = (params) => {
    return API.GET('/website/school/sceneDetails', params)
}
// 获取各个场景使用详情
export const findSceneDetailsList = (params) => {
    return API.GET('/website/school/getSceneDetailsList', params)
}

// 获取活跃教师用户top10
export const findActiveTeacherTop = (params) => {
    return API.GET('/website/school/activeTeacherTop', params)
}

// 获取产品用户总数
export const findUserCount = (params) => {
    return API.GET('/website/DataStatistics/getUserCount', params)
}

// 获取最近30日活跃用户数-分产品
export const findActiveUser = (params) => {
    return API.GET('/website/DataStatistics/getActiveUser', params)
}

// 获取种子用户前10
export const findTopTea = (params) => {
    return API.GET('/website/DataStatistics/getTopTea10', params)
}

// 获取活跃学校排名
export const findTopSch = (params) => {
    return API.GET('/website/DataStatistics/getTopSch10', params)
}

// 获取各模块使用频率
export const findModuleUsed = (params) => {
    return API.GET('/website/DataStatistics/getModuleUsed', params)
}


// 获取全部用户的学科分析
export const findSubjectUsed = (params) => {
    return API.GET('/website/DataStatistics/getSubjectUsed', params)
}

// 获取安装大屏的mac数量、大屏学校数量、大屏班级数量、大屏总用户数
export const findScreenUseNum = (params) => {
    return API.GET('/website/screen/getScreenUseNum', params)
}

// 获取学校使用率
export const findSchoolUsageRate = (params) => {
    return API.GET('/website/school/getSchoolUsageRate', params)
}

// 获取大屏日活用户趋势图
export const findScreenDayUseChar = (params) => {
    return API.GET('/website/screen/getScreenDayUseChar', params)
}

// 获取大屏每周使用人数
export const findScreenWeeklyUseNum = (params) => {
    return API.GET('/website/screen/getScreenWeeklyUseNum', params)
}

// 获取大屏每月用户数量
export const findScreenMonthlyUseNum = (params) => {
    return API.GET('/website/screen/getScreenMonthlyUseNum', params)
}

// 获取大屏每月活跃百分比趋势
export const findScreenMonthlyPercentage = (params) => {
    return API.GET('/website/screen/getScreenMonthlyPercentage', params)
}

// 获取大屏用户学科分析
export const findScreenDisciplineAnaly = (params) => {
    return API.GET('/website/screen/getScreenDisciplineAnalysis', params)
}

// 获取大屏主要行为分布
export const findScreenApplication = (params) => {
    return API.GET('/website/screen/getScreenApplication', params)
}

// 获取大屏top20
export const findScreenTopTwenty = (params) => {
    return API.GET('/website/screen/getScreenTopTwenty', params)
}

// 获取各校学校使用人数
export const findScreenSchoolUserNum = (params) => {
    return API.GET('/website/screen/getScreenSchoolUserNum', params)
}

// 获取主要使用场景排序
export const findScreenSceneRanking = (params) => {
    return API.GET('/website/screen/getScreenSceneRanking', params)
}

// 获取备课助手总用户数
export const findLessonPreparationUseNum = (params) => {
    return API.GET('/website/LessonPreparation/getLessonPreparationUseNum', params)
}

// 获取备课使用排行-前五
export const findLesPreUseRanking = (params) => {
    return API.GET('/website/LessonPreparation/getLessonPreparationUseRanking', params)
}

// 获取备课助手每周使用人次
export const findLesPreUseWeekly = (params) => {
    return API.GET('/website/LessonPreparation/getLessonPreparationUseWeekly', params)
}


// 获取备课助手分校用户总数
export const findLesPreSchoolUseNum = (params) => {
    return API.GET('/website/LessonPreparation/getLessonPreparationSchoolUseNum', params)
}

// 获取备课助手最近30天日活数
export const findLesPreDayNum = (params) => {
    return API.GET('/website/LessonPreparation/getLessonPreparationDayNum', params)
}

// 获取备课助手月活用户
export const findLesPreMonthUseNum = (params) => {
    return API.GET('/website/LessonPreparation/getLessonPreparationMonthUseNum', params)
}

// 获取备课助手各版本用户分布
export const findLessPreVersionNum = (params) => {
    return API.GET('/website/LessonPreparation/getLessonPreparationVersionNum', params)
}
// 获取备课助手的课堂活动
export const findZnbkActivity = (params) => {
    return API.GET('/website/LessonPreparation/znbkActivity', params)
}
// 获取pc的使用场景分布
export const findScenesPcMap = (params) => {
    return API.GET('/website/IntelligentPC/getScenesPcMap', params)
}

// 获取智能PC总用户数
export const findPCUseNum = (params) => {
    return API.GET('/website/IntelligentPC/getPCUseNum', params)
}

// 获取PC种子用户Top10
export const findPCUseTop = (params) => {
    return API.GET('/website/IntelligentPC/getPCUseTop', params)
}

// 获取智能PC每周使用人数
export const findPCUseWeekly = (params) => {
    return API.GET('/website/IntelligentPC/getPCUseWeekly', params)
}

// 获取智能PC最近一月活跃人数
export const findPCWeeklyUseNum = (params) => {
    return API.GET('/website/IntelligentPC/getPCWeeklyUseNum', params)
}

// 获取使用智能PC学校分布
export const findPCUseSchool = (params) => {
    return API.GET('/website/IntelligentPC/getPCUseSchool', params)
}

// 获取移动授课总用户数
export const findUseNum = (params) => {
    return API.GET('/website/mobileTeach/getUseNum', params)
}

// 获取移动授课助手使用Top5
export const findUserTop = (params) => {
    return API.GET('/website/mobileTeach/getUserTop', params)
}

// 获取移动授课助手周活跃用户
export const findUserWeekly = (params) => {
    return API.GET('/website/mobileTeach/getUserWeekly', params)
}

// 获取移动授课助手学校使用情况
export const findUseSchool = (params) => {
    return API.GET('/website/mobileTeach/getUseSchool', params)
}

// 获取移动授课助手主要使用场景
export const findUseScene = (params) => {
    return API.GET('/website/mobileTeach/getUseScene', params)
}

// 获取智能PC用户学科分析
export const findPCSubjectAnaly = (params) => {
    return API.GET('/website/IntelligentPC/getPCSubjectAnaly', params)
}

// 获取备课助手分学科用户
export const findLesPreSubjectUseNum = (params) => {
    return API.GET('/website/LessonPreparation/getLessonPreparationSubjectUseNum', params)
}

// 获取备课助手分学科用户
export const findLessPreSubUseNum = (params) => {
    return API.GET('/website/LessonPreparation/getLessonPreparationSubjectUseNum', params)
}

// 获取移动授课助手学科使用情况
export const findSubjectMap = (params) => {
    return API.GET('/website/mobileTeach/getSubjectMap', params)
}

// 获取移动授课助手用户学科分布
export const findSubjectAnaly = (params) => {
    return API.GET('/website/mobileTeach/getSubjectAnaly', params)
}

// 获取各产品累计用户数每日趋势
export const findLessPreDayUseNum = (params) => {
    return API.GET('/website/LessonPreparation/getLessonPreparationDayUseNum', params)
}

// 获取日期下拉框数据
export const findDateMonth = (params) => {
    return API.GET('/website/school/dateMonth', params)
}

// 获取资源上传人数
export const findTeaWorkCount = (params) => {
    return API.GET('/website/school/selectTeaWorkCount', params)
}

// 获取班级列表
export const findClassList = (params) => {
    return API.GET('/website/bord/classList', params)
}

// 获取教师列表
export const findTeacherList = (params) => {
    return API.GET('/website/bord/teacherList', params)
}

// 获取学生列表
export const findStudentList = (params) => {
    return API.GET('/website/bord/studentList', params)
}

// 获取资源列表
export const findResourceList = (params) => {
    return API.GET('/website/bord/resourceInfoList', params)
}
// 获取微课列表
export const findCoursewaresInfoList = (params) => {
    return API.GET('/website/bord/getCoursewaresInfoList', params)
}

// 获取作业列表
export const findHomeWorkList = (params) => {
    return API.GET('/website/bord/hwStuHomeWorkList', params)
}

// 获取课堂互动列表
export const findInterEvaLList = (params) => {
    return API.GET('/website/bord/screenInterEvaList', params)
}

// 获取学校使用产品详情
export const findClassUsageRate = (params) => {
    return API.GET('/website/school/getClassUsageRate', params)
}

// 获取学校使用产品日期选择
export const findCalendar = (params) => {
    return API.GET('/website/school/getCalendar', params)
}
// 获取布置作业日活、周活、月活用户数
export const findHomeWorkLists = (params) => {
    return API.GET('/website/hworke/getHomeWorkList', params)
}
// 获取布置作业人数
export const findHwUserCount = (params) => {
    return API.GET('/website/hworke/getHwUserCount', params)
}
// 获取作业使用top20学校
export const findHwSchoolList = (params) => {
    return API.GET('/website/hworke/getHwSchoolList', params)
}
// 获取作业使用top20用户
export const findHwUserCountList = (params) => {
    return API.GET('/website/hworke/getHwUserCountList', params)
}
// 获取作业学段饼状图
export const findSubjectMaps = (params) => {
    return API.GET('/website/hworke/getSubjectMap', params)
}
// 获取作业学科分布
export const findSubjectAnalys = (params) => {
    return API.GET('/website/hworke/getSubjectAnaly', params)
}
// 获取作业使用率
export const findHomeWorkCount = (params) => {
    return API.GET('/website/hworke/homeWorkCount', params)
}
// 获取作业种类分析
export const findSubjectName = (params) => {
    return API.GET('/website/hworke/getSubjectName', params)
}
// 获取各校班级作业使用率
export const findTeaList = (params) => {
    return API.GET('/website/school/getTeaList', params)
}
// 获取各产品使用详情
export const findSituationTea = (params) => {
    return API.GET('/website/screen/getSituationTea', params)
}

// 获取中国地图各省学校用户数
export const findProvinceData = (params) => {
    return API.GET('/website/screen/getProvinceData', params)
}

// 根据省code获取各市学校用户数
export const findCityData = (params) => {
    return API.GET('/website/screen/getCityData', params)
}

// 获取各省、市学校用户列表
export const findSchoolUserList = (params) => {
    return API.GET('/website/screen/gradeByProvince', params)
}

// 根据学校id获取学校信息
export const findSchoolInfoById = (params) => {
    return API.GET('/userMgr/baseschool/getSchoolById', params)
}

//获取报告详情
export const findInertactInfo = (params) => {
    return API.GET('/screen/interact/getInertactInfo', params)
}

//获取课堂互动云端报告列表
export const findReportList = (params) => {
    return API.GET('/website/bord/getInteractList', params)
}

//根据作业id获取作业详情
export const findHomeworkInfo = (params) => {
    return API.GET('/homework/teahomework/getTeaHomeWorkById', params)
}

//根据资源id获取资源详情
export const findResourceInfo = (params) => {
    return API.GET('/resource/resource/getDetails', params)
}

//根据课堂互动id获取课堂互动
export const findInterInfo = (params) => {
    return API.GET('/screen/evaluate/getEvaById', params)
}

//根据用户id获取代理商详细信息
export const findAgentInfoByUserId = (params) => {
    return API.GET('/userMgr/agent/getAgentInfoByUserId', params)
}

//学校使用产品详情（班级）
export const getClassCountData = (params) => {
    return API.GET('/website/school/getClassCountData', params)
}

//各产品使用详情
export const getUserCountDataList = (params) => {
    return API.GET('/website/school/getUserCountDataList', params)
}

//安装大屏数量
export const getClassDiskDataList = (params) => {
    return API.GET('/website/school/getClassDiskDataList', params)
}
//活跃教师使用数量（内页具体教师详情）
export const getTeacherCodingKeyList = (params) => {
    return API.GET('/website/school/getTeacherCodingKeyList', params)
}
//活跃教师使用数量/website/school/getScreenDataList
export const getSchoolTeacherDataList = (params) => {
    return API.GET('/website/school/getSchoolTeacherDataList', params)
}
//大屏使用数量
export const getScreenDataList = (params) => {
    return API.GET('/website/school/getScreenDataList', params)
}
//大屏使用数量(内页具体详情)
export const getScreenDataCodingList = (params) => {
    return API.GET('/website/school/getScreenDataCodingList', params)
}
//活跃教师用户top(内页具体详情)
export const getTeacherCodingList = (params) => {
    return API.GET('/website/school/getTeacherCodingList', params)
}
//各校作业产品数据（详情内页）
export const getHomeWorkList = (params) => {
    return API.GET('/website/school/getHomeWorkList', params)
}
//数据展板内页教师饼图
export const getTeacherStat = (params) => {
    return API.GET('/website/bord/getTeacherStat', params)
}
//数据展板内页教师作业列表
export const getTeacherRateList = (params) => {
    return API.GET('/website/bord/getTeacherRateList', params)
}
//数据展板内页学生列表
export const getStudentRateList = (params) => {
    return API.GET('/website/bord/getStudentRateList', params)
}
// 数据展板内页学生饼图
export const getStudentRateMap = (params) => {
    return API.GET('/website/bord/getStudentRateMap', params)
}
// 数据展板教师
export const getTeacherSchoolList = (params) => {
    return API.GET('/website/bord/getTeacherSchoolList', params)
}
// 数据展板资源饼图
export const resourceViewMap = (params) => {
    return API.GET('/website/bord/resourceViewMap', params)
}
// 数据展板作业饼图
export const homeWorkNumMap = (params) => {
    return API.GET('/website/bord/homeWorkNumMap', params)
}
// 数据展板教师数据导出
export const exportTeacherExcel = (params) => {
    return API.GET('/website/bord/exportTeacherExcel', params)
}
export const getTypeOfWork = (params) => {
    return API.GET('/website/hworke/getTypeOfWork', params)
}
// 大屏版本
export const getScreenVersion = (params) => {
    return API.GET('/website/school/versionMap', params)
}
// 活跃学生使用统计
export const getSchoolStudentDataList = (params) => {
    return API.GET('/website/school/getSchoolStudentDataList', params)
}
// 活跃学生内页具体使用统计
export const getStudentCodingKeyList = (params) => {
    return API.GET('/website/school/getStudentCodingKeyList', params)
}
// 大屏日活数据线图
export const getSchoolScreenMap = (params) => {
    return API.GET('/website/school/getSchoolScreenMap', params)
}
//  活跃教师用户top10-查看更多
export const moreTeachers = (params) => {
    return API.GET('/website/school/moreTeachers', params)
}

// 学生机周活日活月活
export const getStudentLiveList = (params) => {
    return API.GET('/website/student/getStudentLiveList', params)
}
// 学生机饼图
export const getStudentCodingKey = (params) => {
    return API.GET("/website/student/getStudentCodingKey", params)
}
// 学生机学校数量
export const getStudentSchool = (params) => {
    return API.GET("/website/student/getStudentSchoolList", params)
}
// 学生机各用户总数
export const getStudentCount = (params) => {
    return API.GET("/website/student/getStudentCount", params)
}
// 大屏重复绑定详情
export const screenRepeatList = (params) => {
    return API.GET("/website/school/screenRepeatList", params)
}
// 教师使用大屏详情内页
export const getSchoolTeacherByIdList = (params) => {
    return API.GET("/website/school/getSchoolTeacherByIdList", params)
}
// 各产品使用详情（用户） 行为编码
export const getCodingDataList = (params) => {
    return API.GET("/website/school/getCodingDataList", params)
}
// 大屏绑定班级数量
export const getAllClassesDisk = (params) => {
    return API.GET("/website/school/getAllClassesDisk", params)
}
// 各校饼图点击进入查看教师详情数据
export const getSchoolTeacherCountKey = (params) => {
    return API.GET("/website/school/getSchoolTeacherCountKey", params)
}
//  数据统计接口
export const activeUsers = (params) => {
    return API.GET("/website/DataStatistics/activeUsers", params)
}
//  大屏具体使用场景详情
export const getFuncCodeCountMap = (params) => {
    return API.GET("/website/school/getFuncCodeCountMap", params)
}
//  各班级数字点击进入查看各班级详情数据
export const getDiskIdByCodingKeyList = (params) => {
    return API.GET("/website/school/getDiskIdByCodingKeyList", params)
}
//资源详情
export const findResourceInfoList = (params) => {
    return API.GET("/website/school/getResourceInfoList", params)
}
//作业学科使用饼图
export const querySubjectMap = (params) => {
    return API.GET("/website/school/getSubjectMap", params)
}
//作业类型使用饼图
export const queryTypeOfWork = (params) => {
    return API.GET("/website/school/getTypeOfWork", params)
}

//产品使用率

// 各校使用率 种子用户点击详情使用超过4天的用户
export const findSeedUserList = (params) => {
    return API.GET("/website/school/getSeedUserList", params)
}
//  各校使用率种子用户点击详情
export const findSeedAllUserList = (params) => {
    return API.GET("/website/school/getSeedAllUserList", params)
}
//  各校使用率大屏使用超过4天得详情
export const findScreenList = (params) => {
    return API.GET("/website/school/getScreenList", params)
}
//  各校使用率大屏使用详情
export const findAllScreenList = (params) => {
    return API.GET("/website/school/getAllScreenList", params)
}
//  各校使用率各产品使用超过4次以上
export const findProductList = (params) => {
    return API.GET("/website/school/getProductList", params)
}
//  各校使用率各产品使用详情
export const findAllProductList = (params) => {
    return API.GET("/website/school/getAllProductList", params)
}
//  各校使用率作业使用详情
export const findAllHomeWorkUsageRateList = (params) => {
    return API.GET("/website/school/getAllHomeWorkUsageRateList", params)
}
//  各校使用率作业使用超过四次以上的详情
export const findHomeWorkUsageRateList = (params) => {
    return API.GET("/website/school/getHomeWorkUsageRateList", params)
}
//智慧课堂

//  一起智慧课堂-用户数与学生数
export const findWisdomScreenUseNum = (params) => {
    return API.GET("/website/wisdom/getScreenUseNum", params)
}
//  一起智慧课堂-日增曲线图与总数曲线图
export const getWisdomDataNum = (params) => {
    return API.GET("/website/wisdom/getDataNum", params)
}
//  一起智慧课堂-前20用户柱状图
export const queryYiqiUserTopTen = (params) => {
    return API.GET("/website/wisdom/getYiqiUserTopTen", params)
}
//  一起智慧课堂-前20学校柱状图
export const queryYiqiSchoolTopTen = (params) => {
    return API.GET("/website/wisdom/getYiqiSchoolTopTen", params)
}
//  一起智慧课堂-学段统计
export const queryYiqiSchoolSectionMap = (params) => {
    return API.GET("/website/wisdom/getYiqiSchoolSectionMap", params)
}
//  一起智慧课堂- 下载资源相关
export const queryYiqiCodingKeyList = (params) => {
    return API.GET("/website/wisdom/getYiqiCodingKeyList", params)
}
//  一起智慧课堂- 模块饼图
export const queryYiqiCodingKeyMap = (params) => {
    return API.GET("/website/wisdom/getYiqiCodingKeyMap", params)
}
//  一起智慧课堂- 学段使用学段饼图
export const queryPieCharts = (params) => {
    return API.GET("/website/wisdom/pieCharts", params)
}
// 一起智慧课堂-每日活跃用户与每日活跃学校
export const queryDayActive = (params) => {
    return API.GET("/website/wisdom/getDayActive", params)
}
// 一起智慧课堂-主要使用场景详情
export const getCodingKeyDetail = (params) => {
    return API.GET("/website/wisdom/codingKeyDetail", params)
}
// 一起智慧课堂-点击学校排名或用户排名
export const getRankingDetail = (params) => {
    return API.GET("/website/wisdom/rankingDetail", params)
}
// 一起智慧课堂-获取省市区
export const getRegion = (params) => {
    return API.GET("/website/wisdom/getRegion", params)
}
// 根据学段查询学校列表
export const getSchoolDetail = (params) => {
    return API.GET("/website/wisdom/getSchoolDetail", params)
}
// 根据学校查询用户列表
export const getSchoolUserList = (params) => {
    return API.GET("/website/wisdom/getSchoolUserList", params)
}
//云白板

// 学校白板统计
export const querySchoolWihteBoardRankList = (params) => {
    return API.GET("/website/wisdom/getSchoolWihteBoardRankList", params)
}
// 用户白板统计
export const queryUserRankList = (params) => {
    return API.GET("/website/wisdom/getUserRankList", params)
}
// 用户使用白板详细记录
export const findUserWhiteBoardDetailList = (params) => {
    return API.GET("/website/wisdom/getUserWhiteBoardDetailList", params)
}
// 总会话次数
export const getConversationCount = (params) => {
    return API.GET("/website/wisdom/conversationCount", params)
}
// 总会话次数——学校列表
export const getConversationSchoolList = (params) => {
    return API.GET("/website/wisdom/conversationSchoolList", params)
}
// 总会话次数-用户列表
export const getConversationUserList = (params) => {
    return API.GET("/website/wisdom/conversationUserList", params)
}
// 总会话次数-对象列表
export const getConversationWith = (params) => {
    return API.GET("/website/wisdom/conversationWith", params)
}
// 一起地区分布
export const queryProvinceData = (params) => {
    return API.GET("/website/wisdom/getProvinceData", params)
}
// 一起智慧课堂用户数班级数列表
export const getGradeByProvince = (params) => {
    return API.GET("/website/wisdom/gradeByProvince", params)
}
// 获取微课数量
export const getMicroLessonCount = (params) => {
    return API.GET("/website/school/getMicroLessonCount", params)
}
// 获取教师上传微课排名
export const getMicroLessonTop = (params) => {
    return API.GET("/website/school/getMicroLessonTop", params)
}
// 获取教师上传微课详情
export const getMicroLessonUserInfo = (params) => {
    return API.GET("/website/school/getMicroLessonUserInfo", params)
}
// 获取学校列表
export const getSchoolList = (params) => {
    return API.GET("/website/screen/gradeByProvince", params)
}
// 获取区域下的学校列表
export const getDistrictSchoolList = (params) => {
    return API.GET("/website/screen/gradeByProvinceTem", params)
}
// 根据用户ID获取该用户拥有的角色列表
export const findByUserIdToList = (params) => {
    return API.GET('/operag/operator/getUserRoleIdList', params);
}
// 获取代理商信息（xj新写）
export const findAgentInfoByUserIdNew = (params) => {
    return API.GET('/operag/agent/getAgentInfoByUserId', params);
}
// 根据区域编码获取省市区名称和编码
export const queryGeographicalByRegionCode = (params) => {
    return API.GET('/stats/baseRegion/queryGeographicalByRegionCode', params);
}
// 根据区域编码获取区域的学校、班级、教师、学生总数量
export const getRegionSchoolInfomation = (params) => {
    return API.GET('/stats/regionDisplayBoard/getRegionSchoolInfomation', params);
}
// 根据区域编码获取下级区域的学校、班级、教师、学生总数量
export const getNextRegionSchoolInfomation = (params) => {
    return API.GET('/stats/regionDisplayBoard/getNextRegionSchoolInfomation', params);
}
// 根据区域编码获取地理位置数据
export const queryBaseRegionCoordinateByRegionCode = (params) => {
    return API.GET('/stats/baseRegion/queryBaseRegionCoordinateByRegionCode', params);
}
// 根据区域编码获取下级区域中每个学段的学校数
export const queryNextRegionSchoolPhase = (params) => {
    return API.GET('/stats/regionDisplayBoard/getNextRegionSchoolPhase', params);
}
// 根据运营获取代理商信息
export const getOperOriginInfoAPI = (params) => {
    return API.GET('/operag/operator/getOperOriginInfo', params);
}
// 获取金陵微校数据
export const getPlatformInformationStatsAPI = (params) => {
    return API.GET('/website/jlwxStats/getPlatformInformationStats', params);
}
// 根据字段和字段值获取用户, 支持参数加密
export const getUserSupportEncryptionValueAPI = (params) => {
    return API.POST('/userMgr/baselogin/getUserSupportEncryptionValue', params);
}



// 学科应用分析
export const getSubjectApplyAnalysisAPI = (params) => {
    return API.GET('/stats/portal/getSubjectApplyAnalysis', params);
}


// 教学活动分析
export const getTeachingActivityAnalysisAPI = (params) => {
    return API.GET('/stats/portal/getTeachingActivityAnalysis', params);
}
// 获取学段列表
export const getPhaseListAPI = (params) => {
    return API.GET('/stats/portal/getPhaseList', params);
}

// 清徐大数据展板
/**
 * @name 根据域名获取平台信息
 **/
export const getPlatFormInfoByPlatformDomainAPI = (params) => {
    return API.POST("/platformManage/getPlatFormInfoByPlatformDomain", params);
};
/**
 * @name 获取平台学校集体备课统计
 **/
export const getPlatformSchoolTeamInviteStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformSchoolTeamInviteStat', params)
}

/**
 * @name 获取平台学校听评课统计
 **/
export const getPlatformSchoolListeningEvaluatingStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformSchoolListeningEvaluatingStat', params)
}

/**
 * @name 获取平台在线答疑统计
 */
export const getPlatformOnlineQaStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformOnlineQaStat', params)
}

/**
 * @name 获取平台名师工作室统计
 */
export const getPlatformMasterStudioStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformMasterStudioStat', params)
}

/**
 * @name 获取平台资源统计
 */
export const getPlatformResourceStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformResourceStat', params)
}

/**
 * @name 获取平台综合评审按类型统计
 */
export const getPlatformActivityTypeStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformActivityTypeStat', params)
}

/**
 * @name 获取平台学校活跃度数据
 */
export const getPlatformSchoolStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformSchoolStat', params)
}

/**
 * @name 获取学年当前时间最近的4个学年及开始结束时间
 */
export const getSchoolYearAPI = (params) => {
    return API.GET('/website/teaching/getSchoolYear', params)
}

/**
 * @name 获取平台各应用使用学校数
 */
export const getPlatformAppUseSchoolStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformAppUseSchoolStat', params)
}

/**
 * @name 获取平台访问按天统计数据
 */
export const getPlatformVisitDayStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformVisitDayStat', params)
}

/**
 * @name 获取平台访问统计数据
 */
export const getPlatformVisitStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformVisitStat', params)
}

/**
 * @name 获取平台在线课程统计
 */
export const getPlatformCourseStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformCourseStat', params)
}

/**
 * @name 获取平台在线课程统计
 */
export const getPlatformSpecialCourseStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformSpecialCourseStat', params)
}

/**
 * @name 获取平台统计
 */
export const getPlatformStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformStat', params)
}

/**
 * @name 区域学校, 用户, 班级数统计
 */
export const getSchoolDfStatAPI = (params) => {
    return API.GET('/website/platformStats/getSchoolDfStat', params)
}

/**
 * @name 获取在校数据统计
 */
export const getAtSchoolDataAPI = (params) => {
    return API.GET('/website/webSiteSchool/getAtSchoolData', params)
}
/**
 * @name 获取用户凭证
 */
export const getQxDataAPI = (params) => {
    return API.POST('clientToken/login/client', params, location.origin + "/xcofficeapi/")
}
/**
 * @name 获取清徐数据统计
 */
export const getBureauStatisticsAPI = (params) => {
    return API.GET('school/getBureauStatistics', params, location.origin + "/xcofficeapi/")
}
/**
 * @name 获取平台资源访问按天统计数据
 */
export const getPlatformResourceVisitDayStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformResourceVisitDayStat', params)
}
/**
 * @name 获取平台资源类型统计指标
 */
export const getPlatformResourceTypeStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformResourceTypeStat', params)
}
/**
 * @name 获取平台各学科资源统计
 */
export const getPlatformSubjectResourceStatAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformSubjectResourceStat', params)
}
/**
 * @name 获取平台教学动态数据
 */
export const getPlatformDynamicDataAPI = (params) => {
    return API.GET('/website/platformStats/getPlatformDynamicData', params)
}

/**
 * @name 上虞获取活动评审数据统计
 */
export const getActivityReviewInfoAPI = (params) => {
    return API.GET('/website/teachingDataPanels/getActivityReviewInfo', params)
}

/**
 * @name 上虞获取在线课程数据统计
 */
export const getOnlineCourseInfoAPI = (params) => {
    return API.GET('/website/teachingDataPanels/getOnlineCourseInfo', params)
}

/**
 * @name 上虞获取资源建设总数
 */
export const getPlatformResourceTotalAPI = (params) => {
    return API.GET('/website/teachingDataPanels/getPlatformResourceTotal', params)
}

/**
 * @name 上虞获取资源分布统计
 */
export const getPlatformResourceDistributionAPI = (params) => {
    return API.GET('/website/teachingDataPanels/getPlatformResourceDistribution', params)
}

/**
 * @name 上虞获取资源类型统计
 */
export const getPlatformResourceTypeAPI = (params) => {
    return API.GET('/website/teachingDataPanels/getPlatformResourceType', params)
}

/**
 * @name 上虞获取备授课活跃排行top10
 */
export const getSchoolProductRankListAPI = (params) => {
    return API.GET('/website/teachingDataPanels/getSchoolProductRankList', params)
}

/**
 * @name 上虞获取教师备授课教学行为分析
 */
export const getTeaBehaviorAPI = (params) => {
    return API.GET('/website/teachingDataPanels/getTeaBehavior', params)
}

/**
 * @name 上虞获取名师工作室统计
 */
export const getMasterStudioInfoAPI = (params) => {
    return API.GET('/website/teachingDataPanels/getMasterStudioInfo', params)
}

/**
 * @name 上虞获取教研活动统计
 */
export const getTeachingResearchInfoAPI = (params) => {
    return API.GET('/website/teachingDataPanels/getTeachingResearchInfo', params)
}

/**
 * @name 上虞获取教学动态
 */
export const getTeachingDynamicAPI = (params) => {
    return API.GET('/website/teachingDataPanels/getTeachingDynamic', params)
}

/**
 * @name 上虞获取考试统计
 */
export const getExamStatAPI = (params) => {
    return API.GET('/homeworkstatic/exam/getExamStat', params, VUE_APP_EXAM)
}

/**
 * @name 上虞获取区域学校考试数据统计
 */
export const getExamSchStatAPI = (params) => {
    return API.GET('/homeworkstatic/exam/getExamSchStat', params, VUE_APP_EXAM)
}
/**
 * @name 上虞获取精准教学统计列表
 */
export const getAreaStat = (params) => {
    return API.GET('/pscan/_/get-area-stat', params, VUE_APP_KKL)
}
/**
 * @name 上虞获取大单元加工所有学科建设的总题量
 */
export const getQuesStatAPI = (params) => {
    return API.GET('/pbook/stat/getQuesStat', params, VUE_APP_KKL)
}

/**
 * @name 上虞获取所有学校或者某学校下所有老师的题目使用数据统计
 */
export const getUseQueListAPI = (params) => {
    return API.GET('/testbank/testBank/getUseQueList', params)
}
/**
 * @name 教师备课资源-我的课本
 */
export const getBookList = (params) => {
    return API.GET('/resource/userbook/list', params, VUE_APP_SCREENURL)
}
/**
 * @name 教师备课资源-我当前选中的课本
 */
export const getCommonCatchList = (params) => {
    return API.GET('/public/catch/getCommonCatchList', params)
}
/**
 * @name 教师备课资源-课本教材下目录
 */
export const getStructureCatalogList = (params) => {
    return API.GET('/resource/catalog/getStructureCatalogList', params)
}
/**
 * @name 教师备课资源-课本教材下的资源
 */
export const getResourceList = (params) => {
    return API.GET('/resource/center/getResourceList', params)
}